var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaintPatrick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1040 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M690.75 945.99H590.63c-17.83 0-32.31-14.48-32.31-32.31v-21.02c0-6.23 5.06-11.29 11.29-11.29h121.14c17.83 0 32.31 14.48 32.31 32.31 0 17.83-14.48 32.31-32.31 32.31z",
    fill: "#F79253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557.32 881.66l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31",
    stroke: "#F05360",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M781.71 360.53c27.66 105.97-77.07 135.49-77.07 135.49l28.96 156.04c164.75-100.29 142.58-244.17 110.84-313.7-6.08-13.32-20.14-21.1-34.66-19.22-19.88 2.58-33.13 21.99-28.07 41.38v.01z",
    fill: "#036D79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M824.89 570.519c20.59-28.68 32.28-58.24 37.82-86.84 5.54-28.6 4.94-56.24.98-81.07-3.97-24.83-11.3-46.86-19.24-64.24a33.394 33.394 0 00-5.94-8.89c-2.4-2.58-5.18-4.74-8.23-6.42-3.05-1.69-6.35-2.9-9.81-3.57-3.46-.67-7.06-.81-10.69-.34-4.97.64-9.52 2.34-13.48 4.83a33.568 33.568 0 00-9.9 9.56c-2.58 3.8-4.39 8.12-5.23 12.71-.84 4.59-.72 9.44.55 14.29 6.92 26.49 5.56 48.21-.37 65.88",
    stroke: "#044548",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.71 763.09v53.29c0 14.23-11.53 25.76-25.76 25.76h-6.02c-14.23 0-25.76 11.53-25.76 25.76 0 14.23 11.53 25.76 25.76 25.76H426",
    fill: "#2C848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M741.39 452.01v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H403.86c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V452.01c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z",
    fill: "#2C848E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M680.291 223.066c12.271-12.27 12.271-32.164.001-44.435-12.271-12.27-32.165-12.27-44.435 0l-66.058 66.058c-12.27 12.271-12.27 32.165 0 44.435 12.27 12.27 32.164 12.27 44.435 0l66.057-66.058z",
    fill: "#2C848E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M623.775 204.451c12.27-12.271 12.27-32.165 0-44.435-12.27-12.27-32.164-12.27-44.435 0l-66.058 66.058c-12.27 12.27-12.27 32.164 0 44.435 12.271 12.27 32.165 12.27 44.435 0l66.058-66.058z",
    fill: "#2C848E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M579.34 160.01c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92M443.52 331.789c9.98-9.98 23.75-16.18 38.9-16.18 15.15 0 28.91 6.2 38.9 16.18M603.94 331.789c9.98-9.98 23.75-16.18 38.9-16.18 15.15 0 28.91 6.2 38.9 16.18",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M681.39 778.06V626.29c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M533.4 700.71c22.854 0 41.38-18.526 41.38-41.38 0-22.853-18.526-41.38-41.38-41.38-22.854 0-41.38 18.527-41.38 41.38 0 22.854 18.526 41.38 41.38 41.38z",
    fill: "#58BB5F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M533.4 754.821c22.854 0 41.38-18.527 41.38-41.38 0-22.854-18.526-41.38-41.38-41.38-22.854 0-41.38 18.526-41.38 41.38 0 22.853 18.526 41.38 41.38 41.38zM603.86 700.71c22.854 0 41.38-18.526 41.38-41.38 0-22.853-18.526-41.38-41.38-41.38-22.854 0-41.38 18.527-41.38 41.38 0 22.854 18.526 41.38 41.38 41.38z",
    fill: "#58BB5F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M603.86 754.821c22.854 0 41.38-18.527 41.38-41.38 0-22.854-18.526-41.38-41.38-41.38-22.854 0-41.38 18.526-41.38 41.38 0 22.853 18.526 41.38 41.38 41.38z",
    fill: "#58BB5F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M523.01 686.38h91.24",
    stroke: "#1E9562",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M576.79 668.22h-16.32c-5.523 0-10 4.477-10 10v16.32c0 5.523 4.477 10 10 10h16.32c5.523 0 10-4.477 10-10v-16.32c0-5.523-4.477-10-10-10z",
    fill: "#58BB5F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M576.79 668.22c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32zm0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#1E9562"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M482.42 383.41h-.01c-32.839 0-59.46 26.621-59.46 59.46v49.27c0 32.839 26.621 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.839-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M476.38 521.6c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46 16.24 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z",
    fill: "#044548"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M486.43 470.97l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93zM696.35 436.93c0-29.558-23.96-53.52-53.515-53.52-29.556 0-53.515 23.962-53.515 53.52v61.15c0 29.558 23.959 53.52 53.515 53.52 29.555 0 53.515-23.962 53.515-53.52v-61.15z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M632.63 521.6c-14.62 0-26.52-13.22-26.52-29.46v-49.26c0-16.25 11.9-29.46 26.52-29.46s26.52 13.22 26.52 29.46v49.26c0 16.25-11.9 29.46-26.52 29.46z",
    fill: "#044548"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M624.01 470.699l-17.47 11.21c-2.53 1.62-5.84-.19-5.84-3.19v-22.42c0-3 3.32-4.81 5.84-3.19l17.47 11.21c2.33 1.49 2.33 4.89 0 6.39v-.01z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M541.88 440.91v-6.11c0-32.71-26.76-59.46-59.46-59.46s-59.46 26.76-59.46 59.46v6.11h118.93-.01z",
    fill: "#2C848E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M482.42 375.34c-32.7 0-59.46 26.76-59.46 59.46v6.11h118.93",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M705.97 440.91v-6.11c0-32.71-26.76-59.46-59.46-59.46s-59.46 26.76-59.46 59.46v6.11h118.93-.01z",
    fill: "#2C848E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M646.51 375.34c-32.7 0-59.46 26.76-59.46 59.46v6.11h111.93",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M762.707 285.869l-536.976 94.684c-14.761 2.603-24.618 16.679-22.015 31.44 2.603 14.762 16.679 24.618 31.441 22.015l536.976-94.683c14.761-2.603 24.618-16.679 22.015-31.441-2.603-14.761-16.679-24.617-31.441-22.015zM327.874 104.131l244.301-43.077c53.663-9.462 104.913 26.424 114.375 80.086l16.074 91.164-438.761 77.365-16.075-91.164c-9.462-53.662 26.424-104.912 80.086-114.374z",
    fill: "#58BB5F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M700.48 183.204l-451.407 79.595 18.348 104.055 451.406-79.596-18.347-104.054z",
    fill: "#044548"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M628.324 189.597l-124.381 21.932c-5.227.921-8.717 5.905-7.796 11.132l17.179 97.427a9.611 9.611 0 0011.133 7.796l124.381-21.932a9.611 9.611 0 007.796-11.133l-17.179-97.427c-.922-5.227-5.906-8.717-11.133-7.795z",
    fill: "#F79253"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M601.027 194.403l-50.176 8.847 20.516 116.355 50.176-8.847-20.516-116.355z",
    fill: "#FED425"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M625.593 277.909l-9.527-54.026a4 4 0 00-4.634-3.245l-80.99 14.281a4 4 0 00-3.245 4.634l9.526 54.026a4.001 4.001 0 004.634 3.245l80.991-14.281a4.001 4.001 0 003.245-4.634z",
    fill: "#044548"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M247.79 218.51c-9.47-53.7 26.39-104.91 80.09-114.38l244.3-43.08M235.15 434.01c-14.76 2.6-28.84-7.25-31.44-22.02-2.6-14.76 7.25-28.84 22.02-31.44l536.98-94.68",
    stroke: "#1E9562",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M606.07 494.771h-68.88c-14.172 0-25.66 11.488-25.66 25.66 0 14.171 11.488 25.66 25.66 25.66h68.88c14.171 0 25.66-11.489 25.66-25.66 0-14.172-11.489-25.66-25.66-25.66z",
    fill: "#FED425"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M511.53 520.421v12.17c0 22.09 17.91 40 40 40h27.86c16.57 0 30-13.43 30-30v-12.17l-97.86-10z",
    fill: "#FED425"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M597.92 541.01h-37.51c-11.17 0-21.57-5.73-27.53-15.18",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194.7 713.59l33.8 30.07h116.82V528.53c0-17.26-20.4-26.42-33.29-14.94L194.7 617.96c-28.62 25.46-28.62 70.18 0 95.64v-.01z",
    fill: "#2C848E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M334.78 684.61l-107.51-95.63-32.57 28.971c-28.62 25.459-28.62 70.18 0 95.64l63.81 56.759c37 32.91 95.51 6.65 95.51-42.87 0-16.38-7-31.98-19.24-42.87z",
    fill: "#2C848E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M194.7 617.95c-28.62 25.46-28.62 70.18 0 95.64l63.81 56.76c37 32.91 95.51 6.65 95.51-42.87 0-16.38-7-31.98-19.24-42.87L309.7 663.2l18.7-18.7",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M334.51 881.37h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.83-14.48 32.31-32.31 32.31H334.51c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    fill: "#F79253"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M465.93 881.66l1 32.02c0 17.77-14.54 32.31-32.31 32.31H334.5c-17.77 0-32.31-14.54-32.31-32.31",
    stroke: "#F05360",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaintPatrick);
export default ForwardRef;